import { Box, Tooltip, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import useStyles from "./styles";

export function ChipPrioridade(prioridade) {
  const theme = useTheme();
  const styles = useStyles(theme);

  const config = {
    Baixa: {
      label: "Baixa",
      tooltip: "Prioridade baixa",
      bgColor: theme.palette.colors.blue.medium,
    },
    Normal: {
      label: "Normal",
      tooltip: "Prioridade normal",
      bgColor: theme.palette.colors.pink.medium,
    },
    Média: {
      label: "Média",
      tooltip: "Prioridade média",
      bgColor: theme.palette.colors.purple.medium,
    },
    Alta: {
      label: "Alta",
      tooltip: "Prioridade alta",
      bgColor: theme.palette.colors.orange.medium,
    },
    Crítica: {
      label: "Crítica",
      tooltip: "Prioridade crítica",
      bgColor: theme.palette.colors.red.medium,
    },
    Urgente: {
      label: "Urgente",
      tooltip: "Prioridade urgente",
      bgColor: theme.palette.colors.red.medium,
    },
  };

  const current = config[prioridade];
  if (!current) return null;

  return (
    <Tooltip placement="top" title={current.tooltip}>
      <Box
        sx={{
          ...styles.boxPrioridade,
          backgroundColor: current.bgColor,
        }}
      >
        <Typography sx={styles.textPrioridade}>{current.label}</Typography>
      </Box>
    </Tooltip>
  );
}
